import { ValidationMessage } from './validationMessage';

export class ServiceException {
    constructor(public isBusinessException: boolean, public errors: ValidationMessage[]) { }
}